class NavigationService {
  constructor($rootScope, $http) {
    "ngInject";
    this.$rootScope = $rootScope;
    this.$http = $http;
  }

  getMenu(lang) {
    //return this.$http.get(this.$rootScope.config.api2 + 'cms/nav?lang=' + lang).then((result) => {
    return this.$http.get(this.$rootScope.config.api + 'cms/nav/?lang=' + lang, {
      headers: this.$rootScope.config.tokenHeader
    }).then((result) => {
      return result;
    }, (response) => {
      console.error(response);
    });
  }

}

export default NavigationService;



// WEBPACK FOOTER //
// ./client/app/common/navigation/navigation.service.js